import PropTypes from 'prop-types';

const PanelPropTypes = {
  group: PropTypes.string,
  type: PropTypes.string,
  launchProps: PropTypes.shape({
    index: PropTypes.number,
    type: PropTypes.string,
    authorIndex: PropTypes.number,
    publicationIndex: PropTypes.number,
  }),
  index: PropTypes.number,
};

export default PanelPropTypes;
